"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaginationRefetch = void 0;
const react_1 = require("react");
const usePaginationRefetch = ({ refetch, }) => {
    const paginationRefetchCountRef = (0, react_1.useRef)(0);
    const [isPaginationRefetching, setIsPaginationRefetching] = (0, react_1.useState)(false);
    const paginationRefetch = (0, react_1.useCallback)((variables) => {
        // Keep a counter outside render state so overlapping page changes do not hide the loader early.
        paginationRefetchCountRef.current += 1;
        setIsPaginationRefetching(true);
        return refetch(variables).finally(() => {
            paginationRefetchCountRef.current -= 1;
            if (paginationRefetchCountRef.current === 0) {
                setIsPaginationRefetching(false);
            }
        });
    }, [refetch]);
    return {
        isPaginationRefetching,
        paginationRefetch,
    };
};
exports.usePaginationRefetch = usePaginationRefetch;
